import {baseSelector, useSliceDispatch} from "../../utils";
import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {useSelector} from "react-redux";
import {PlaylistActions} from "./actions";
import {PlaylistSliceState} from "./redcuers";

type PlaylistDispatch = PlaylistActions;
export const usePlaylistDispatch = () => useSliceDispatch<PlaylistDispatch>();

export const selectPlaylistSlice = createSelector(
    [
        (state: RootState) => state.playlist,
        (state: RootState, keys: (keyof PlaylistSliceState)[]) => keys
    ],
    (slice, keys) => baseSelector(slice, keys)() // Call the baseSelector function here to get the selected props
);

export const usePlaylistSelector = (keys: (keyof PlaylistSliceState)[]) => {
    return useSelector((state: RootState) => selectPlaylistSlice(state, keys));
}


